export default __webpack_public_path__ + "static/media/Bandeau 8.9294d334.jpg";